import { emptyObj } from 'util/objects'

export const base = state => state.kb.knowledgeBases || emptyObj
